export const DESCRIPTION_MAX_HEIGHT_PX = 420;
export const CRUISE_LINES_INITIAL_VISIBLE_COUNT = 10;
